import type { ReactNode } from 'react';
import { FormattedMessage, type MessageDescriptor } from 'react-intl';

import type { PlanPriceDisplayCopy } from './types';

function isMessageDescriptor(value: PlanPriceDisplayCopy): value is MessageDescriptor {
  return (
    typeof value === 'object' &&
    value !== null &&
    'id' in value &&
    'defaultMessage' in value
  );
}

export function renderPlanPriceDisplayCopy(content: PlanPriceDisplayCopy): ReactNode {
  if (isMessageDescriptor(content)) {
    return <FormattedMessage {...content} />;
  }

  return content;
}
